import type { SVGProps } from 'react';
const SvgCircleCheckSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
    <path d="M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10m4.61-14.309a.937.937 0 0 0-1.31.207l-4.663 6.415-2.035-2.036a.937.937 0 0 0-1.324 1.324l2.812 2.813c.195.195.46.293.734.274a.92.92 0 0 0 .684-.383L14.816 7a.937.937 0 0 0-.207-1.309" />
  </svg>
);
export default SvgCircleCheckSolid;
